import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";

const OPTIONS = {
  day: {
    min: 0,
    step: 1,
  },
  hour: {
    min: 0,
    max: 23,
    step: 1,
  },
};

@Component
export default class Duration extends Vue {
  @Prop(Number) readonly value: number;
  @Prop({ default: () => ["day", "hour"] }) readonly keys: Array<string>;

  values = {
    day: 0,
    hour: 0,
  };

  @Watch("value", { immediate: true })
  valueChange(value = 0) {
    const hours = Number(value) / 3600;
    const day = Math.floor(hours / 24);
    const hour = hours % 24;
    this.values = {
      day: day,
      hour: hour,
    };
  }

  triggerChange(type) {
    return (value) => {
      const { day, hour } = {
        ...this.values,
        [type]: value,
      } as any;

      const result = (day * 24 + hour) * 3600;
      this.$emit("change", result);
    };
  }

  render() {
    const items = this.keys.map((key) => {
      const props = {
        ...OPTIONS[key],
        value: this.values[key],
      };

      return (
        <div style={{ marginRight: "8px", display: "inline-block" }}>
          <a-input-number
            {...{ props: props }}
            onChange={this.triggerChange(key)}
          ></a-input-number>
          <span style="margin-left:8px">{this.$t(key)}</span>
        </div>
      );
    });
    return <div>{items}</div>;
  }
}
